/* eslint-disable */
import * as types from "../actions/types";

const initialState = {
  personnel: [],
  // расход ещё не строился — до первого ответа сервера пустых состояний не показываем
  personnelLoaded: false,
  // право изменять отметки приходит вместе с расходом
  canEditAbsence: null,
  absentGrades: [],
  permanentStaff: [],
  divisions: [],
  groupsBySchedule: [],
  courses: [],
  pagesCount: 0,
  totalCount: 0,
  isLoading: false,
};

export default function umk(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_PERSONNEL_COMPLETED:
      return {
        ...state,
        personnel: action.payload.groups,
        canEditAbsence: action.payload.canEdit ?? null,
        personnelLoaded: true,
        isLoading: false,
      };
    case types.FETCH_PERSONNEL_FAILED:
      return {
        ...state,
        personnel: [],
        personnelLoaded: true,
        isLoading: false,
      };
    // отметка одного обучающегося: расход не перезапрашивается
    case types.SET_RASHOD_ABSENCE:
      return {
        ...state,
        personnel: state.personnel.map(group =>
          String(group.gid) !== String(action.payload.gid) ? group : {
            ...group,
            students: (group.students || []).map(student =>
              String(student.mid) !== String(action.payload.mid) ? student : {
                ...student,
                absence: action.payload.absence,
              }),
          }),
      };
    case types.FETCH_GRADES_COMPLETED:
      return {
        ...state,
        absentGrades: action.payload,
      };
    case types.SET_PERMANENT_STAFF:
      return {
        ...state,
        permanentStaff: action.payload,
        isLoading: false
      };
    case types.SET_PERMANENT_STAFF_PAGES_COUNT:
      return {
        ...state,
        pagesCount: action.payload.pagesCount,
        totalCount: action.payload.totalCount,
      };
    case types.SET_DIVISIONS:
      return {
        ...state,
        divisions: action.payload,
      };
    case types.RASHOD_REMOVE:
      return {
        ...initialState,
      };
    case types.RASHOD_FETCH_STARTED:
      return {
        ...state,
        isLoading: true,
      };
    case types.SET_GROUPS_BY_SCHEDULE:
      return {
        ...state,
        groupsBySchedule: action.payload,
      };
    case types.SET_RASHOD_COURSES:
      return {
        ...state,
        courses: action.payload,
      };
    default:
      return state;
  }
}
